import React from "react";
import "./components/css/build_common.css";
import ChooseProduct from "./components/chooseproduct";
import BuildCUNew from "./components/buildcunew";
import BuildUCNew from "./components/builducnew";
import BuildSystem from "./components/builldsystem";
import Match from "./components/match";
import { withTranslation } from 'react-i18next';
import {StateAmbContext} from '../stateContext';
import packageSettings from '../packageSettings.json';

var initialState = {
    tool: "",
    path: ["chooseproduct"],
    boxloaded:false,
    CU: {
        AWEF: "Yes",
        brand: "bohn",
        brandLock:false,
        count: 1,
        temp: "Medium Temp (Cooler)",
        voltage: "208-230/1/60",
        ref: "R-448A",
        compressor: "Scroll",
        unit_style:"Outdoor",
        btuh: 5000,
        amb_temp: 95,
        sst:25 ,
        selected_model: "",
        selected_option: "A0000",
        total_price :0,
        defrost:"Air Defrost",
        models: [
            {
                model: "",
                label: "",
                btuh: 0,
                price: 0,
                awef:7.6,
                count:1,
                key:"cu_lower",
                option_packages: [
                    { code: "A0000", label: "Air Defrost Timer", price: 0 },
                    { code: "A0200", label: "Dummy Timer", price: 0 },
                    { code: "A0300", label: "Another Timer", price: 0 },
                    { code: "A0400", label: "Testing Timer", price: 0 }

                ],
                technical_data: [
                    { label: "Capacity", value: 0 },
                    { label: "MCA", value: 0 },
                    { label: "MOPD", value: 0 }
                    
                ]
            },
            {
                model: "",
                label: "",
                btuh: 0,
                price: 0,
                awef:7.6,
                count:1,
                key:"cu_recom",
                option_packages: [
                    { code: "A0000", label: "Air 2nd model Defrost Timer", price: 0 },
                    { code: "A0200", label: "Dummy 2nd model Timer", price: 0 },
                    { code: "A0300", label: "Another 2nd model Timer", price: 0 },
                    { code: "A0400", label: "Testing 2nd modelTimer", price: 0 }

                ],
                technical_data: [
                    { label: "Capacity", value: 0 },
                    { label: "MCA", value: 0 },
                    { label: "MOPD", value: 0 }
                ]
            },
            {
                model: "",
                label: "",
                btuh: 0,
                price: 0,
                awef:7.6,
                count:1,
                key:"cu_upper",
                option_packages: [
                    { code: "A0000", label: "third Air Defrost Timer", price: 0 },
                    { code: "A0200", label: "third Dummy Timer", price: 0 },
                    { code: "A0300", label: "third Another Timer", price: 0 },
                    { code: "A0400", label: "third Testing Timer", price: 0 }

                ],
                technical_data: [
                    { label: "Capacity", value: 0 },
                    { label: "MCA", value: 0 },
                    { label: "MOPD", value: 0 }
                ]
            }
        ],

    },
    UC: {
        AWEF: "Yes",
        count: 1,
        td: 10,
        brand:"bohn",
        brandLock:false,
        ref:"R-448A",
        temp:"Medium Temp (Cooler)",
        voltage: "115/1/60",
        defrost: "Air Defrost",
        motor: "2-Speed EC",
        selected_model: "",
        selected_option: "B0000",
        total_price :0,
        btuh: 5000,
        amb_temp: 95,
        model_style:"Low Profile",
        sst: 25,
        area:0,
        height:7.2,
        aMin:"",
        zone:"",
        rds:"Factory Installed",
        models: [
            {
                model: "",
                label: "",
                btuh: 0,
                price: 0,
                awef:7.6,
                count:1,
                option_packages: [
                    { code: "B0000", label: "Air Defrost Timer", price: 0 },
                    { code: "B0200", label: "Dummy Timer", price: 0 },
                    { code: "B0300", label: "Another Timer", price: 0 },
                    { code: "B0400", label: "Testing Timer", price: 0 }

                ],
                technical_data: [
                    { label: "Capacity", value: 27588 },
                    { label: "MCA", value: 20 },
                    { label: "MOPD", value: 55 }
                ]
            },
            {
                model: "",
                label: "",
                btuh: 0,
                price: 0,
                awef:7.6,
                count:1,
                option_packages: [
                    { code: "B0000", label: "Air 2nd model Defrost Timer", price: 0 },
                    { code: "B0200", label: "Dummy 2nd model Timer", price: 0 },
                    { code: "B0300", label: "Another 2nd model Timer", price: 0 },
                    { code: "B0400", label: "Testing 2nd modelTimer", price: 0 }

                ],
                technical_data: [
                    { label: "Capacity", value: 0 },
                    { label: "MCA", value: 0 },
                    { label: "MOPD", value: 0 }
                ]
            },
            {
                model: "",
                label: "",
                btuh: 0,
                price: 0,
                awef:7.6,
                count:1,
                option_packages: [
                    { code: "B0000", label: "third Air Defrost Timer", price: 0 },
                    { code: "B0200", label: "third Dummy Timer", price: 0 },
                    { code: "B0300", label: "third Another Timer", price: 0 },
                    { code: "B0400", label: "third Testing Timer", price: 0 }

                ],
                technical_data: [
                    { label: "Capacity", value: 0 },
                    { label: "MCA", value: 0 },
                    { label: "MOPD", value: 0 }
                ]
            }
        ],

    },
    match: {
        balance: 0,
        total_price:0,
        total_price_counts : 0
    }
};




class QuickSelection extends React.Component {
    static contextType = StateAmbContext;
    
    constructor(props){
        super(props);
        this.state = initialState;
    }
    componentDidMount(){
        localStorage.removeItem('area');
        localStorage.removeItem('areaDisable');
        localStorage.removeItem('rds');
        localStorage.setItem('a2lToggle', false)
        const { settings, updateStateAmb }  = this.context;
        var params = {};
        window.brandBlocker = (brandName,brandLock=true)=>{
            var predefinedBrands = ["bohn","climate_control","larkin","chandler"];
            if (predefinedBrands.indexOf(brandName)> -1){
                var custate = {...this.state.CU};
                var ucstate = {...this.state.UC};
                var initialState_CU = {...initialState.CU};
                var initialState_UC = {...initialState.UC};
                if(this.state.tool === "" || this.state.tool==="System"){
                    custate['brand'] = brandName;
                    custate['brandLock'] = brandLock;
                    ucstate['brand'] = brandName;
                    ucstate['brandLock'] = brandLock;

                    initialState_CU = {...initialState_CU, brand:brandName,brandLock:brandLock};                    
                    initialState_UC = {...initialState_UC, brand:brandName,brandLock:brandLock};                    
                                                 
                }else if(this.state.tool === "Condensing Unit"){
                    custate['brand'] = brandName;
                    custate['brandLock'] = brandLock;
                    initialState_CU = {...initialState_CU, brand:brandName,brandLock:brandLock};                    

                                     
                }else if(this.state.tool === "Evaporator"){
                    ucstate['brand'] = brandName;
                    ucstate['brandLock'] = brandLock;
                    initialState_UC = {...initialState_UC, brand:brandName,brandLock:brandLock};                     
                }
                initialState = {...initialState,CU:initialState_CU, UC:initialState_UC };             
                this.setState({ UC:ucstate,CU:custate });
        
            }
        }
        
        try{
            var url_string = window.location.href;
            var url = new URL(url_string);
            var boxObj = url.searchParams.get("boxObj");
            var params = JSON.parse(boxObj);
            const { boxloadState, dataAmbsState } = {...params};
            var hold_CU  = {...this.state.CU,...boxloadState}
            if(boxloadState.temp==="Low Temp (Freezer)"){
                boxloadState['defrost'] = "Electric Defrost";

            }else{
                if(boxloadState.sst === 20){
                    boxloadState['defrost'] = "Electric Defrost";
                }
            }
            var hold_UC = {...this.state.UC,...boxloadState}
            this.setState({CU:hold_CU,UC:hold_UC,boxloaded:true})
            updateStateAmb(dataAmbsState);          
        }catch{
            var a = "";

        }
    }

    navigate = (selectedpage) => {
        var path = [...this.state.path];
        var tool = this.state.tool;
        tool = (selectedpage === "buildsystem") ? "System" : tool;
        tool = (selectedpage === "buildcu") ? "Condensing Unit" : tool;
        tool = (selectedpage === "builduc") ? "Evaporator" : tool;
        var stateObj = {};
        if (selectedpage === "match") {
            selectedpage = "match";
            this.hubFunctions(3);
        }
        if (selectedpage === "prev") {
            path.pop();
            if((path[path.length - 1])==="chooseproduct"){
                this.setState(initialState);
                this.hubFunctions(1);
                this.resetUpdateStateAmb();
            }else{
                this.hubFunctions(2);
            }
        }
        else if (selectedpage === "start-over") {
            tool = "chooseproduct";
            path = ["chooseproduct"]
            this.setState(initialState);
            this.hubFunctions(1);
            this.resetUpdateStateAmb();
        }
        else {
            path.push(selectedpage);
            var pdt_page = ['buildsystem','buildcu','builduc'];
            if(pdt_page.indexOf(selectedpage)>-1){
                this.hubFunctions(2);
            }
        }
        stateObj['tool'] = tool
        stateObj['path'] = path
        this.setState(stateObj)
    }
    updateNewPrice = async(unitName,materialModels)=>{
        var CU = { ...this.state.CU };
        var UC = { ...this.state.UC };
        var match = {...this.state.match};
        if (unitName === "UC"){
            let ucmodels = UC.models.map(model=>{
                var priceObj = materialModels[model.model];
                if (priceObj == undefined){
                   return model
                }
                let ops = model.option_packages.map(op=>{
                    if (priceObj[op.code]===undefined){
                        return op
                    }else{
                        var err_msg  = priceObj[op.code]['error_message'];
                            op.err_code = ( priceObj[op.code]['err_code'] );
                            op.price = ( priceObj[op.code]['price'] ==="-" ?err_msg: priceObj[op.code]['price']);
                            op.errFlag = ( priceObj[op.code]['price'] ==="-" ? true: false );
                            if(["R-455A","R-454A","R-454C"].includes(UC.ref) && op.code === "G0000"){
                                model.price =   ( priceObj[op.code]['price'] ==="-" ?err_msg: priceObj[op.code]['price']);
                            }
                            if (op.code === "B0000"){
                                model.price =   ( priceObj[op.code]['price'] ==="-" ?err_msg: priceObj[op.code]['price']);
                            }
                            // console.log("op",UC.ref)
                            return op;
                    }
                });
                model.option_packages = ops;
                return  model;
            })
            UC['models'] = ucmodels;
            this.setState({UC:UC});
            

        }
        else if (unitName === "CU"){
            let cumodels = CU.models.map(model=>{
                var priceObj = materialModels[model.model];
                if (priceObj == undefined){
                    return model
                }
                let ops = model.option_packages.map(op=>{
                if (priceObj[op.code]===undefined){
                    return op
                }else{
                    var err_msg  = priceObj[op.code]['error_message'];
                        op.err_code = ( priceObj[op.code]['err_code'] );
                        op.price = ( priceObj[op.code]['price'] ==="-" ?err_msg: priceObj[op.code]['price']);
                        op.errFlag = ( priceObj[op.code]['price'] ==="-" ? true: false );
                        if (op.code === "A0000"){
                         model.price =   ( priceObj[op.code]['price'] ==="-" ?err_msg: priceObj[op.code]['price']);
                        }
                        return op;
                }
                });
                model.option_packages = ops;
                return  model;
            });
            CU['models'] = cumodels;
            this.setState({CU:CU});

            
    }
    this.update_price(CU,UC,match);
}
    update_price=(CU,UC,match) =>{
        var cumodel = CU.models.find((e) => {
            if (CU.selected_model == e.model)
                return e;
        });
        var ucmodel = UC.models.find((e) => {
            if (UC.selected_model == e.model)
                return e;
        });
        var ucmodel_option = ucmodel.option_packages.find((e) => {
            if (UC.selected_option == e.code )
                return e;
        });

        var cumodel_option = cumodel.option_packages.find((e) => {
            if (CU.selected_option == e.code)
                return e;
        });
        //// For Evaporator per unit condensor
        var condensor_multiplier = 1 ;
        if (this.state.tool === "System"){
            condensor_multiplier = Number(cumodel.count) ;
        }
       
        var cu_price= (Number(cumodel_option.price )) ;
        var uc_price= (Number(ucmodel_option?.price || 0) * condensor_multiplier) ;
        var total_price= cu_price + uc_price;
        
        
        var cu_price_count= (Number(cumodel_option.price)* Number(cumodel.count)) ;
        var uc_price_count= (Number(ucmodel_option?.price || 0) * Number(ucmodel.count) * (condensor_multiplier) ) ;
        var total_price_counts = cu_price_count+ uc_price_count;
        
        match.total_price = (isNaN(total_price)?0:total_price);
        match.total_price_counts = (isNaN(total_price_counts)?0:total_price_counts);

        CU.total_price = (isNaN(cu_price)?0:cu_price);
        CU.total_price_counts = (isNaN(cu_price_count)?0:cu_price_count);

        UC.total_price_counts = (isNaN(uc_price_count)?0:uc_price_count);
        UC.total_price = (isNaN(uc_price)?0:uc_price);
        this.setState({UC:UC,CU:CU,match:match})

    }
    update_cu_states = (type, value) => {
        var CU = { ...this.state.CU };
        var UC = {...this.state.UC};
        var match = {...this.state.match};
        CU[type] = value;
        //to select the recommended card
        if(type === "ref"){
            CU['ref'] = value;
            UC['ref'] = value;
        }
        if (type==="sst" && value<=0){ 
            // alert("am in 1")
            CU['temp'] = "Low Temp (Freezer)"
            CU['sst'] = value
            UC['defrost'] = "Electric Defrost"
            UC['voltage'] ="208-230/1/60"
        }else if (type==="sst" && value>20){ //value>0
            // alert("Am in 2")
            CU['temp'] = "Medium Temp (Cooler)"
            CU['sst'] = value
            UC['defrost'] = "Air Defrost"
            UC['voltage'] ="115/1/60"
        }
        else if (type==="sst" && value>0 && value<25){ //added on request
            // alert("Am in 3")
            CU['temp'] = "Medium Temp (Cooler)"
            CU['sst'] = value
            UC['defrost'] = "Electric Defrost"
            UC['voltage'] ="115/1/60"
        }
        else if (type==="temp" && value==="Low Temp (Freezer)"){
           
            CU['sst'] = -20
            UC['defrost'] = "Electric Defrost"
            UC['voltage'] ="208-230/1/60"
            UC['motor'] = "Fixed Speed EC"
            if( UC['td'] === "11" ){
                UC['td'] = "10"
            }
        }
        else if(type==="temp" && value==="Medium Temp (Cooler)"){
            CU['sst'] = 25
            UC['defrost'] = "Air Defrost"
            UC['voltage'] ="115/1/60"
            UC['motor'] = "2-Speed EC"
            if (UC['td'] === "8"){
                UC['td'] = "10"
            }
        }
        if(type==="models"){
            var recomm_flag = false;
            var index = 0;
            for(let i=0;i<value.length;i++){
                if (value[i].label==="RECOMMENDED"){
                    recomm_flag = true;
                    index = i;
                    break;
                }
            }
            if (recomm_flag){
                CU['selected_model'] = value[index].model;
            }else{
                value[index]['label'] = "";
                value[index]['btuh'] = 10000000;
                CU['selected_model'] = value[index].model;
            }
            CU['selected_option'] = "A0000"
        }
        this.setState({CU:CU,UC:UC})
        this.update_price(CU,UC,match);
    }
    update_uc_states = (type, value) => {
        const { settings, updateStateAmb }  = this.context;
        var CU = { ...this.state.CU };
        var UC = {...this.state.UC};
        var match = {...this.state.match};
        UC[type] = value;
        if(type === "ref"){
            UC['ref'] = value;
        }
        if (type==="sst" && value<=0){
            UC['temp'] = "Low Temp (Freezer)"
            UC['sst'] = value
            UC['defrost'] = "Electric Defrost"
            UC['voltage'] ="208-230/1/60"
        }else if (type==="sst" && value>0){
            UC['temp'] = "Medium Temp (Cooler)"
            UC['sst'] = value
            UC['defrost'] = "Air Defrost"
            UC['voltage'] ="115/1/60"
        }
        else if (type==="temp" && value==="Low Temp (Freezer)"){
            UC['sst'] = -20
            UC['defrost'] = "Electric Defrost"
            UC['voltage'] ="208-230/1/60"
            UC['motor'] = "Fixed Speed EC"
        }
        else if(type==="temp" && value==="Medium Temp (Cooler)"){
            UC['sst'] = 25
            UC['defrost'] = "Air Defrost"
            UC['voltage'] ="115/1/60"
            UC['motor'] = "2-Speed EC"
        }
        //to select the recommended card
        if(type==="models"){
            var recomm_flag = false;
            var index = 0;
            for(let i=0;i<value.length;i++){
                if (value[i].label==="RECOMMENDED"){
                    recomm_flag = true;
                    index = i;
                    break;
                }
            }
            if (recomm_flag){
                UC['selected_model'] = value[index].model;
            }else{
                value[index]['label'] = "";
                UC['selected_model'] = value[index].model;
            }

            if(this.state.tool === "Evaporator" && (UC['ref'] === "R-455A" || UC['ref'] === 'R-454A' || UC['ref'] === 'R-454C') && UC['rds'] === 'Factory Installed') {
                UC['selected_option'] = "G0000";
            }else if(this.state.tool === "System" && (CU['ref'] === "R-455A" || CU['ref'] === 'R-454A' || CU['ref'] === 'R-454C') && UC['rds'] === 'Factory Installed') {
                UC['selected_option'] = "G0000"; 
            }else{
                UC['selected_option'] = "B0000"  
            }

            // Filter prefered Packages
                var currentPackageFilter =  packageSettings[UC['model_style']];
                if (currentPackageFilter && (currentPackageFilter != undefined)){
                    var allowedPackages =  (this.state.tool==="System"? currentPackageFilter[CU['ref']] :currentPackageFilter[UC['ref']]) ;
                    if (allowedPackages && allowedPackages != undefined){
                        
                            var definedModelStyle = ["Center Mount","Low Profile","Medium Profile","Large Unit Coolers"];
                            if( definedModelStyle.indexOf(this.state.UC.model_style)>-1 ){
                                if( this.state.UC.defrost === "Electric Defrost" &&  this.state.UC.temp === "Medium Temp (Cooler)" ){
                                    allowedPackages = ["B0000"];
                                }
                            }
                            var amb_temp_val = this.state.tool === "System"?this.state.CU.amb_temp:this.state.UC.amb_temp;
                            // when ambient is >110 and a2l refs selected to add G package otherwise add B Package
                        if(this.state.tool === "System"){
                            if( Number(amb_temp_val) > 110 ){
                                if((this.state.CU.ref === "R-455A" || this.state.CU.ref === "R-454A" || this.state.CU.ref === "R-454C") && localStorage.getItem('rds') === "Factory Installed"){
                                    allowedPackages = ["G0000"];
                                }else{
                                    allowedPackages = ["B0000"];
                                }
                            }}
                            // when ambient is >110 and a2l refs selected to add G package otherwise add B Package
                            if(this.state.tool === "Evaporator"){
                            if( Number(amb_temp_val) > 110 ){
                                if((this.state.UC.ref === "R-455A" || this.state.UC.ref === "R-454A" || this.state.UC.ref === "R-454C") && this.state.UC.rds === "Factory Installed"){
                                    allowedPackages = ["G0000"];
                                }else{
                                    allowedPackages = ["B0000"];
                                }
                            }}

                            // when sst is === -30 and a2l refs selected to add G package otherwise add B Package
                            var sst_val = this.state.tool === "System"?this.state.CU.sst:this.state.UC.sst;

                            if(this.state.tool === "System"){
                                if( Number(sst_val) === -30  ){
                                    if((this.state.CU.ref === "R-455A" || this.state.CU.ref === "R-454A" || this.state.CU.ref === "R-454C") && localStorage.getItem('rds') === "Factory Installed"){
                                        allowedPackages = ["G0000"];
                                    }else{
                                        allowedPackages = ["B0000"];
                                    }
                                }   
                            }
                            // when sst is === -30 and a2l refs selected to add G package otherwise add B Package

                            if(this.state.tool === "Evaporator"){
                                // console.log("sst_val UC",sst_val)

                                if( Number(sst_val) === -30  ){
                                    if((this.state.UC.ref === "R-455A" || this.state.UC.ref === "R-454A" || this.state.UC.ref === "R-454C") && this.state.UC.rds === "Factory Installed"){
                                        allowedPackages = ["G0000"];
                                    }else{
                                        allowedPackages = ["B0000"];
                                    }
                                }   
                            }

                        for(let j=0;j<value.length;j++){
                            var holdPack = value[j]['option_packages'];
                            var filteredPacks = holdPack.filter(obj=> allowedPackages.indexOf(obj['code'])>-1);
                            value[j]['option_packages'] = filteredPacks;
            
                        }
                    }
                }

        }
        this.setState({UC:UC,CU:CU})
        this.update_price(CU,UC,match);
    }
    
    update_uc_min_and_zone = (aminValue, zoneValue) => {
        let UC = {...this.state.UC};
        let CU = {...this.state.CU};
        let match = {...this.state.match};
        
        if (aminValue !== undefined) {
            UC['aMin'] = aminValue;
        }
        if (zoneValue !== undefined) {
            UC['zone'] = zoneValue;
        }
        
        this.setState({UC:UC, CU:CU});
        this.update_price(CU,UC,match);
    }
    resetUpdateStateAmb = ()=>{
        const { updateStateAmb } = this.context;
        var dataAmbsState = {
            w:6,
            h: 8,
            l: 6,
            saved: false,
            roomtemp: 35,
            application: "cooler",
            typical_btuh: 0,
            heavy_btuh: 0,
            boxloaded: false,
            selected_option : "typical",
            room_area: 0,
            room_vol: 0
            };
        
        updateStateAmb(dataAmbsState);
    };

    Quickloader_changeView = ()=>{
        var a = "";
    }

    hubFunctions = (item)=>{
        const { settings }  = this.context;

        try{
            if(settings.is_hub){    
                if( typeof (window.HC.Selection.loadPage) === 'function' ){
                    
                    window.HC.Selection.loadPage(item);
                }
            }
        }catch(err){
          var a = "";
        }
    };

    render() {
        const {t} = this.props;       
        var current_page = this.state.path[this.state.path.length - 1];
        const { stateAmb,updateStateAmb }  = this.context;
        //BEcause the brand and temp we not available in UC
        if (this.state.tool === "System"){
            let optedModel = this.state.CU.models.filter(model=>{return model.model=== this.state.CU.selected_model});
            if(optedModel.length > 0){
                var uc_state = {...this.state.UC,"btuh":this.state.CU.btuh,'sst':this.state.CU.sst,'ref':this.state.CU.ref,'temp':this.state.CU.temp,'unit_style':this.state.CU.unit_style,'brand':this.state.CU.brand,'area':this.state.UC.area,'height':this.state.UC.height};
            }
        }else{
            var uc_state = {...this.state.UC,
                'area': this.state.UC.area,
                'height': this.state.UC.height,
            };
        }
        //restoring selected model
        var selected_cu = this.state.CU.models.find(item=>{
            if (item['model'] === this.state.CU.selected_model){
                return item;
            };
        });
        var selected_uc = this.state.UC.models.find(item=>{
            if (item['model'] === this.state.UC.selected_model){
                return item;
            };
        }); 
       var datacu = {...this.state.CU,models:selected_cu};
       var datauc ={ ...uc_state,models:selected_uc};

        return (
        <div>
            <div id="stateDataStore" style={{display:"none"}} data-tool={JSON.stringify(this.state.tool)} data-statedatacu={JSON.stringify(datacu)} data-statedatauc={JSON.stringify(datauc)} ></div>
            {(current_page === "chooseproduct") ? <ChooseProduct tool={this.state.tool} navigate={this.navigate} /> : <></>}
            {(current_page === "builduc" || current_page === "system_builduc") ? <BuildUCNew updateNewPrice={this.updateNewPrice} boxloaded={this.state.boxloaded} tool={this.state.tool} navigate={this.navigate} activevalue={uc_state} update={this.update_uc_states} match = {this.state.match} update_uc_min_and_zone={this.update_uc_min_and_zone}/> : <></>}     
            {(current_page === "buildcu" || current_page === "system_buildcu") ? <BuildCUNew updateNewPrice={this.updateNewPrice} boxloaded={this.state.boxloaded} tool={this.state.tool} navigate={this.navigate} activevalue={this.state.CU} update={this.update_cu_states}  match = {this.state.match}/> : <></>}
            {(current_page === "buildsystem") ? <BuildSystem updateNewPrice={this.updateNewPrice} boxloaded={this.state.boxloaded} tool={this.state.tool} navigate={this.navigate} activevalue_CU={this.state.CU} activevalue_UC={uc_state} update_cu={this.update_cu_states} update_uc={this.update_uc_states} match = {this.state.match} update_uc_min_and_zone={this.update_uc_min_and_zone}/> : <></>}
            {(current_page === "match") ? <Match updateNewPrice={this.updateNewPrice} tool={this.state.tool} navigate={this.navigate} CU={this.state.CU}  UC={this.state.UC}  match = {this.state.match} update_cu ={this.update_cu_states}   update_uc ={this.update_uc_states}   /> : <></>}
        </div>
        );
    }

}
export default withTranslation() (QuickSelection);